import { render, staticRenderFns } from "./Raport.vue?vue&type=template&id=87fd860a&scoped=true"
import script from "./Raport.vue?vue&type=script&lang=js"
export * from "./Raport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fd860a",
  null
  
)

export default component.exports